import React from "react";
import LabelComponent from "../../UniversalComponents/LabelComponent";
import InputComponent from "../../UniversalComponents/InputComponent";
import { parseJSONValue } from "../../../utils/json/parseJSONValue";
import { parseAndExtract } from "../../../utils/utilityFunctions/stringUtility";

const HyperlinkFieldsSubmit = ({
  Value,
  onChange,
  UrlValue,
  onChangeUrl,
  textareaRef,
  maxLength,
  isMandatory,
  handleInput,
}) => {
  console.log("Valuelast", Value);
  // console.log("Valuelast", typeof Value);
  //  console.log("Valuelast", JSON.parse(Value));

  return (
    <div className="flex flex-col px-4 ">
      <div className="my-2">
        <LabelComponent htmlFor="name-input" labelText="Name" size="small" isMandatory={isMandatory} />
        <InputComponent
          type="text"
          name="textForUrl"
          id="name-input"
          value={Value?.textForUrl}
          onChange={onChange}
          ref={textareaRef}
          autoFocus
          maxLength={maxLength}
        />
      </div>
      <div className="">
        <LabelComponent htmlFor="url-input" labelText="URL" size="small" isMandatory={isMandatory} />
        <textarea
          name="url"
          id="url-input"
          rows={2}
          className="resize-none  bg-white border  focus:outline-hidden focus:ring-0 focus:border-[#7A7D84] active:border active:border-DFE2E5 text-base font-400 block  border-[#DFE2E5] rounded-md placeholder-[rgba(56,56,56,0.40)]  w-full !h-[20px] !min-h-[40px] items-center"
          onInput={handleInput}
          value={Value?.url}
          onChange={onChange}
          ref={textareaRef}
          autoFocus
        ></textarea>
      </div>
    </div>
  );
};

export default HyperlinkFieldsSubmit;
